import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiService } from '../../../service/api.service';

@Component({
  selector: 'app-viewwarning',
  templateUrl: './viewwarning.component.html',
  styleUrls: ['./viewwarning.component.scss']
})
export class ViewwarningComponent implements OnInit {

  constructor(public matDialog: MatDialog,
    public dialogRef: MatDialogRef<ViewwarningComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private ApiService: ApiService,) { }

  save(data) {
    console.log(data);
    this.ApiService.updateNode(data)
      .then((data: any) => {
        // this.dialogRef.close(true);        
      })
  }

  closeModal() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.modalData.forEach(element => {
      if (!element.birth) {
        element.birth = {
          date: { year: '', month: '', day: '' },
          place: ""
        }
      }
      if (!element.birth.date) {
        element.birth.date = { year: '', month: '', day: '' }
      }
      if (!element.death) {
        element.death = {
          date: { year: '', month: '', day: '' },
        }
      }
      if (!element.death.date) {
        element.death.date = { year: '', month: '', day: '' }
      }
      if (!element.birth?.place) {
        element.birth.place = ""
      }
      if (!element.birth?.date?.year) {
        element.birth.place = ""
      }
      if (!element.birth?.date?.month) {
        element.birth.date.month = ""
      }
      if (!element.birth?.date.day) {
        element.birth.date.day = ""
      }
      if (!element.death?.place) {
        element.death.place = ""
      }
      if (!element.death?.date?.year) {
        element.death.place = ""
      }
      if (!element.death?.date?.month) {
        element.death.date.month = ""
      }
      if (!element.death?.date.day) {
        element.death.date.day = ""
      }
    });
  }

}
